module.exports = __webpack_public_path__ + "img/17-Trade India.e545c260.jpg";